import * as Yup from 'yup';
import { IPasswordRecoveryFormValues } from '../passwordRecoveryFormValues';

export default class PasswordRecoveryModelHelper {
    public static createFormValues = () : IPasswordRecoveryFormValues => {
        return {
            password: '',
            confirmPassword: '',
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IPasswordRecoveryFormValues> => Yup.object({
        password: Yup.string().required('Required'),
        confirmPassword: Yup.string().oneOf([Yup.ref('password')], 'Passwords do not match.').required('Required'),
    });
}